import { z } from 'zod';
import { graphConfigSchema } from '../schemas';

export const correctionStepSchema = z.object({
  step_index: z.number().int().min(1),
  sub_statement_md: z.string().max(4096).nullable().default(null),
  part_level: z.number().int().min(1).max(3).nullable().default(null),
  equation_before_md: z.string().max(2048).nullable().default(null),
  equation_after_md: z.string().max(2048).nullable().default(null),
  transformation_label_md: z.string().max(256).nullable().default(null),
  /**
   * Le résultat de la ligne — ce que l'élève écrirait au cahier.
   * En mode équation, identique à equation_after_md.
   */
  result_md: z.string().min(1).max(2048),
  explanation_md: z.string().min(1).max(4096),
  property_md: z.string().max(2048).nullable().default(null),
  lesson_slug: z.string().max(80).nullable().default(null),
  graph_config: graphConfigSchema,
});

export const correctionSchema = z.object({
  title: z.string().min(1).max(200),
  context_md: z.string().max(16384).nullable().default(null),
  statement_md: z.string().min(1).max(16384),
  difficulty: z.enum(['easy', 'medium', 'hard']),
  estimated_minutes: z.number().int().min(1).max(120),
  step_by_step_mode: z.boolean().default(false),
  graph_config: graphConfigSchema,
  steps: z.array(correctionStepSchema).min(2),
});

export type Correction = z.infer<typeof correctionSchema>;
export type CorrectionStep = z.infer<typeof correctionStepSchema>;
